const getCartDataFromUtag = () => ({
	order_currency_code: window.utag_data.order_currency_code,
	product_sku: window.utag_data.product_sku,
	product_category: window.utag_data.product_category,
	product_quantity: window.utag_data.product_quantity,
	product_price: window.utag_data.product_price
});

export default getCartDataFromUtag;
